export const rightHeaderLinksConstants = {
    TOP_NAV_LINK_RIGHT_CLASS: 'header__top-nav-link-right',
    RIGHT_NAV_TITLE_CLASS: 'right-nav-title',
    MEMBER_RIGHT_NAV_TITLE_CLASS: 'member-right-nav-title',
    HIDDEN_CLASS: 'hidden'
};

